import * as fromAvailability from '../actions/availability.action';

export interface AvailabilityState {
  data: any;
  freelancers: any;
  loaded: Boolean;
  loading: Boolean;
  error: string;
}

export const initialState = {
  data: null,
  freelancers: null,
  loaded: false,
  loading: false,
  error: null
};

export function reducer(state = initialState, action: fromAvailability.AvailabilityAction): AvailabilityState {
  switch (action.type) {
    case fromAvailability.GET_AVAILABILITY: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromAvailability.GET_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    }
    case fromAvailability.GET_AVAILABILITY_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: null,
        error: action.payload
      };
    }

    case fromAvailability.GET_AVAILABLE_FREELANCERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromAvailability.GET_AVAILABLE_FREELANCERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        freelancers: action.payload,
        error: null,
      };
    }
    case fromAvailability.GET_AVAILABLE_FREELANCERS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/reducers/availability.reducer.ts